import React, { useEffect, useState } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import { reduxForm } from 'redux-form';
import RipsApi from '../api/RipsApi';
import ThirdsApi from '../../Reports/api/thirds_api';
import TextField from '@material-ui/core/TextField';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import ListRips from './ListRips';
import ListRipsActions from './ListRipsActions';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const Default = ({ history, location }) => {

    //Terceros
    const [thirds, setThirds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //Parametros de Generacion
    const [idThird, setIdThird] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [invoice, setInvoice] = useState(0);
    const [rips, setRIPS] = useState([]);
    const [contractsThird, setContractsThird] = useState([]);
    const [contract, setContract] = useState(null);
    const [thridPlusContract, setThridPlusContract] = useState([]);
    const [wholeThird, setWholeThird]= useState(null);
    const [idContract, setIdContract] = useState(null);

    //Checkbox de RIPS
    const [AF, setAF] = useState(false);
    const [US, setUS] = useState(false);
    const [AC, setAC] = useState(false);
    const [AP, setAP] = useState(false);
    const [AD, setAD] = useState(false);
    const [AM, setAM] = useState(false);
    const [AH, setAH] = useState(false);//No Disponible
    const [AN, setAN] = useState(false);//No disponible
    const [AT, setAT] = useState(false);//No disponible
    const [AU, setAU] = useState(false);//No disponible
    const [CT, setCT] = useState(true);//Control

    useEffect(() => {
        //Lista solo los terceros
        if (thirds.length <= 0) {
            listThirds();
        }
        //lista terceros + contrato
        if(thridPlusContract.length <= 0){
            listThirdsPlusContract();
        }
        //valida las facturas según el tercero
        /* if (idThird != null && startDate != null && endDate != null && invoice == 0) {
            validateInvoices();
        } */
        //valida las facturas según el tercero + el contrato
        if (idThird != null && idContract != null && startDate != null && endDate != null && invoice == 0) {
            validateInvoicesFromThirdAndContract();
        }
    }, [idThird, idContract, startDate, endDate, invoice]);

    const getListRegisters = async (third) => {
        await RipsApi.listarRegistroRips(third).then(response => {
            setRIPS(response);
        }).catch(error => {
            console.log(error);
        });
    }

    const validateInvoices = async () => {
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        }
        await RipsApi.listarFacturasParaRips(dataSend).then(response => {
            setInvoices(response);
        }).catch(error => {
            console.log(error);
        });
    }

    const validateInvoicesFromThirdAndContract = async () => {
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_contrato: idContract,
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        }
        await RipsApi.loadThirdPartyInvoicesWithContract(dataSend).then(response =>{
            setInvoices(response);
        }).catch(error => {
            console.log("Error al cargar las facturas",error);
        })
    }

    const listThirds = async () => {
        await ThirdsApi.listThirdsReports().then((res) => {
            setThirds(res);
            //console.log(res);
        }).catch((err) => {
            console.log(err);
        });
    }

    const listThirdsPlusContract = async () => {
        await ThirdsApi.loadThirdPlusContract().then((res) => {
            setThridPlusContract(res);
            //console.log(res);
        }).catch((err) => {
            console.log(err);
        });
    }

    const listPlans = async (id_third) => {
        await ThirdsApi.getContracts(id_third).then((res) => {
            console.log("RESPONSE", res)
            setContractsThird(res);
        })
            .catch((error) => {
                console.log(error);
            })
        console.log("STATECONT", contractsThird)
    }

    const downloadZIP = async () => {
        setIsLoading(true);
        let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');

        let archivosPlanos = {
            AF: AF,
            US: US,
            AC: AC,
            AP: AP,
            AD: AD,
            AH: AH,
            AM: AM,
            AN: AN,
            AT: AT,
            AU: AU,
            CT: CT
        };

        let dataSend = {
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            id_clinica: sessionStorage.getItem('id_clinica'),
            id_factura: invoice,
            archivos_planos: archivosPlanos,
            id_contrato: idContract
        }

        await RipsApi.generarArchivosPlanosRIPS(dataSend).then(response => {
            let blob = response;
            RipsApi.consultarUltimoConsecutivo().then(resp => {
                if (blob != null) {
                    setIsLoading(false);
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = resp.rip.numero_envio + ".zip";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    if (idThird != null) {
                        getListRegisters(idThird);
                    }
                }
                else {
                    setIsLoading(false);
                    alert("Ha ocurrido un error generando los RIPS, es posible que no halla cerrado Admisiones o no existan Facturas con los filtros indicados");
                }
            })
        }).catch(err => {
            alert("Ha ocurrido un error generando los RIPS, por favor intente nuevamente");
            console.log(err);
            setIsLoading(false);
        });
    }

    const ListRIPSRegisters = () => {
        return (
            <ListRips reactTableData={rips} ReactTableActions={ListRipsActions} />
        );
    }

    const handleChangeThirds = (third) => {
        setInvoice(0);
        setIdThird(third);
        getListRegisters(third);
    }

    const handleChangeThirdsPlusContract = (third) => {
        setInvoice(0);
        setWholeThird(third);
        setIdThird(third.id_tercero);
        setIdContract(parseInt(third.id_contrato));
        getListRegisters(third.id_tercero);
        console.log("TERCERO_CONTRATO", third);
    }

    const handleChangeStartDate = async (date) => {
        setInvoice(0);
        setStartDate(date);
    }

    const handleChangeEndDate = async (date) => {
        setInvoice(0);
        setEndDate(date);
    }

    const handleChangeAFCheckbox = (value, checked) => {
        setAF(checked);
    }

    const handleChangeUSCheckbox = (value, checked) => {
        setUS(checked);
    }

    const handleChangeACCheckbox = (value, checked) => {
        setAC(checked);
    }

    const handleChangeAPCheckbox = (value, checked) => {
        setAP(checked);
    }

    const handleChangeADCheckbox = (value, checked) => {
        setAD(checked);
    }

    const handleChangeAMCheckbox = (value, checked) => {
        setAM(checked);
    }

    const handleChangeCTCheckbox = (value, checked) => {
        setCT(checked);
    }

    const handleChangeContractThird = (contract) => {
        setContract(contract)
    }

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col md={12}>
                        <h5 style={{ color: '#757575' }}>
                            Seleccione el Tercero y el Rango de Fechas para generar los RIPS.
                        </h5>
                        <br />
                    </Col>
                    {/* <Col md={3}>
                        <TextField
                            id="select_third"
                            select
                            label="Tercero"
                            value={idThird}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                handleChangeThirds(event.target.value);
                                //listPlans(event.target.value);
                            }}
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                        >
                            {thirds.map((third) => {
                                return <MenuItem key={third.id_tercero} value={third.id_tercero}>
                                    {third.nombre}
                                </MenuItem>
                            })}
                        </TextField>
                    </Col> */}
                    <Col md={3}>
                        <TextField
                            id="select_third"
                            select
                            label="Tercero + Contrato"
                            value={wholeThird}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                handleChangeThirdsPlusContract(event.target.value);
                                //listPlans(event.target.value);
                            }}
                            style={{ minWidth: '300px', maxWidth: '100%' }}
                        >
                            {thridPlusContract.map((third, index) => {
                                return <MenuItem key={index} value={third}>
                                    {third.nombre_tercero_concatenado}
                                </MenuItem>
                            })}
                        </TextField>
                    </Col>
                    <Col md={3}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Inicial"
                                views={["year", "month", "date"]}
                                value={startDate}
                                onChange={(date) => {
                                    handleChangeStartDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                            />
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col md={3}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <DatePicker
                                disableFuture
                                openTo="date"
                                label="Fecha Final"
                                views={["year", "month", "date"]}
                                value={endDate}
                                onChange={(date) => {
                                    handleChangeEndDate(date);
                                }}
                                className='medical-material-form__field'
                                animateYearScrolling
                                format="yyyy/MM/D"
                            />
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col md={3}>
                        {
                            <TextField
                                id="select-invoice-generate"
                                select
                                label="Factura"
                                value={invoice}
                                className='medical-material-form__field'
                                onChange={(event) => {
                                    setInvoice(event.target.value);
                                }}
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                            >
                                <MenuItem key={0} value={0}>
                                    Facturas del Rango de Fechas
                                </MenuItem>
                                {invoices.map((inv) => {
                                    return <MenuItem key={inv.id_factura_t} value={inv.id_factura_t}>
                                        {inv.num_fac_ter}
                                    </MenuItem>
                                })}
                            </TextField>
                        }
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_AF_FormLabel"}
                            value={AF}
                            control={
                                <MedicalCheckbox
                                    id={"chkxAF"}
                                    checked={AF}
                                    onChange={(event, check) => {
                                        handleChangeAFCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"AF"}
                            labelPlacement={"AF"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_US_FormLabel"}
                            value={US}
                            control={
                                <MedicalCheckbox
                                    id={"chkxUS"}
                                    checked={US}
                                    onChange={(event, check) => {
                                        handleChangeUSCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"US"}
                            labelPlacement={"US"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_AC_FormLabel"}
                            value={AC}
                            control={
                                <MedicalCheckbox
                                    id={"chkxAC"}
                                    checked={AC}
                                    onChange={(event, check) => {
                                        handleChangeACCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"AC"}
                            labelPlacement={"AC"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_AP_FormLabel"}
                            value={AP}
                            control={
                                <MedicalCheckbox
                                    id={"chkxAP"}
                                    checked={AP}
                                    onChange={(event, check) => {
                                        handleChangeAPCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"AP"}
                            labelPlacement={"AP"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_AD_FormLabel"}
                            value={AD}
                            control={
                                <MedicalCheckbox
                                    id={"chkxAD"}
                                    checked={AD}
                                    onChange={(event, check) => {
                                        handleChangeADCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"AD"}
                            labelPlacement={"AD"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_AM_FormLabel"}
                            value={AM}
                            control={
                                <MedicalCheckbox
                                    id={"chkxAM"}
                                    checked={AM}
                                    onChange={(event, check) => {
                                        handleChangeAMCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"AM"}
                            labelPlacement={"AM"}
                        />
                    </Col>
                    <Col md={1}>
                        <FormControlLabel
                            id={"chkx_CT_FormLabel"}
                            value={CT}
                            control={
                                <MedicalCheckbox
                                    disabled={true}
                                    id={"chkxCT"}
                                    checked={CT}
                                    onChange={(event, check) => {
                                        handleChangeCTCheckbox(event.target.value, check)
                                    }}
                                    iconStyle={{ fill: 'green' }}
                                />
                            }
                            label={"CT"}
                            labelPlacement={"CT"}
                        />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={12}>
                        <br />
                        {isLoading ? <Spinner animation="border" variant="success" /> :
                            <Button
                                onClick={() => {
                                    downloadZIP();
                                }}
                                className="btn btn-primary text-white"
                            >
                                Generar y Descargar
                            </Button>
                        }
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <ListRIPSRegisters />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}

export default reduxForm({
    form: 'horizontal_form_reports',
})(Default);